'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWindow = require('react-window');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _calculateListHeight(options, maxHeight) {
    var height = 0;

    for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        height += 30;

        if (height > maxHeight) {
            return maxHeight;
        }
    }

    return height;
}

var MenuList = function (_React$PureComponent) {
    (0, _inherits3.default)(MenuList, _React$PureComponent);

    function MenuList() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MenuList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf2.default)(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'menu-list', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MenuList, [{
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                options = _props.options,
                children = _props.children,
                maxHeight = _props.maxHeight,
                getValue = _props.getValue,
                height = _props.height;

            var _getValue = getValue(),
                _getValue2 = (0, _slicedToArray3.default)(_getValue, 1),
                value = _getValue2[0];

            var indexValue = options.indexOf(value);
            var initialOffset = options.indexOf(value) * height;

            return _react2.default.createElement(
                _reactWindow.FixedSizeList,
                {
                    'data-testid': this.getDataTestId(),
                    height: _calculateListHeight(options, maxHeight),
                    itemCount: children.length,
                    itemSize: height,
                    initialScrollOffset: indexValue > -1 && indexValue > 10 ? initialOffset : undefined
                },
                function (_ref2) {
                    var index = _ref2.index,
                        style = _ref2.style;
                    return _react2.default.createElement(
                        'span',
                        { style: (0, _assign2.default)({ overflow: 'hidden' }, style) },
                        children[index]
                    );
                }
            );
        }
    }]);
    return MenuList;
}(_react2.default.PureComponent);

exports.default = MenuList;


MenuList.defaultProps = {
    height: 30,
    maxHeight: 300
};